var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotpress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.214 38.93l8.286 4.8c1 .577 1.588 1.588 1.588 2.743v9.528c0 1.155-.577 2.165-1.588 2.743l-8.277 4.812a3.13 3.13 0 0 1-3.176 0l-8.277-4.812c-1-.577-1.588-1.588-1.588-2.743v-8.95L17.877 35.898l3.802 5.63-4.764 2.743a3.13 3.13 0 0 1-3.176 0l-8.277-4.81c-1-.577-1.588-1.588-1.588-2.743V27.19c0-1.155.577-2.165 1.588-2.743l8.277-4.812a3.13 3.13 0 0 1 3.176 0l4.138 2.406 3.657 2.117 12.5-7.218V7.99c0-1.155.577-2.165 1.588-2.743L47.086.433a3.13 3.13 0 0 1 3.176 0l8.277 4.812c1 .577 1.588 1.588 1.588 2.743v9.48c0 1.155-.577 2.165-1.588 2.743l-8.277 4.812a3.13 3.13 0 0 1-3.176 0l-4.138-2.406-.24-.144 4.33-6.448-20.26 11.693v8.42l12.5 7.218 3.657-2.117 4.138-2.406c1-.48 2.165-.48 3.128.096z",
    fill: "#4ebeb8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotpress);
export default __webpack_public_path__ + "static/media/botpress.78b41b1d961a5129d2db73a858160fdd.svg";
export { ForwardRef as ReactComponent };